if (!customElements.get("td-lp-combined-free-gift")) {
  class TdLpCombinedFreeGift extends HTMLElement {
    constructor() {
      super();
      // Get all free gift elements
      this.freeGiftElements = this.querySelectorAll('[data-free-gift-parent-id]');
    }

    connectedCallback() {
      // Listen for free gift update events from the product selector
      document.addEventListener('free-gift-update', (e) => this.handleFreeGiftUpdate(e));
    }

    handleFreeGiftUpdate(event) {
      const { productId, purchaseType } = event.detail;

      // Find the currently active gift and the new matching gift
      const currentActive = this.querySelector('.td-gift-active');
      const newMatch = this.querySelector(`[data-free-gift-parent-id="${productId}"]`);
      const shouldShow = newMatch && purchaseType === 'subscription';

      // If swapping between two products that both have free gifts,
      // skip the animation to prevent layout shift / flash
      if (currentActive && shouldShow && currentActive !== newMatch) {
        currentActive.style.transition = 'none';
        newMatch.style.transition = 'none';
        currentActive.classList.remove('td-gift-active');
        newMatch.classList.add('td-gift-active');

        // Re-enable transitions after the swap
        requestAnimationFrame(() => {
          currentActive.style.transition = '';
          newMatch.style.transition = '';
        });
        return;
      }

      // Otherwise, toggle normally with transitions
      this.freeGiftElements.forEach(freeGift => {
        const freeGiftProductId = freeGift.getAttribute('data-free-gift-parent-id');
        
        if (freeGiftProductId === productId && purchaseType === 'subscription') {
          freeGift.classList.add('td-gift-active');
        } else {
          freeGift.classList.remove('td-gift-active');
        }
      });
    }
  }

  customElements.define("td-lp-combined-free-gift", TdLpCombinedFreeGift);
}
